// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1dgdn","rightAdornment":"Header_rightAdornment__3vQhw"};